const TUI_GREEK_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Νούμερο', 'Αριθμός Κάρτας'],
  cardExpiry: ['Λήγει', 'Ισχύει μέχρι']
};
const TUI_GREEK_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Μονόχρωμο', 'Nτεγκραντέ'],
  toolbarTools: {
    undo: 'Αναίρεση',
    redo: 'Επαναφορά',
    font: 'Γραμματοσειρά',
    fontStyle: 'Ύφος Γραμματοσειράς',
    fontSize: 'Μέγεθος Γραμματοσειράς',
    bold: 'Έντονος',
    italic: 'Πλαγίος',
    underline: 'Υπογράμμισή',
    strikeThrough: 'Διαγράμμιση κειμένου',
    justify: 'Στοίχιση',
    justifyLeft: 'Στοίχιση αριστερά',
    justifyCenter: 'Στοίχιση στο κέντρο',
    justifyRight: 'Στοίχιση δεξιά',
    justifyFull: 'Πλήρης στοίχιση',
    list: 'Λίστα',
    indent: 'Εσοχή',
    outdent: 'Αφαίρεση εσοχής',
    unorderedList: 'Μη ταξινομημένη λίστα',
    orderedList: 'Ταξινομημένη λίστα',
    quote: 'Παράθεση',
    foreColor: 'Χρώμα',
    backColor: 'Χρώμα φόντου',
    hiliteColor: 'Χρώμα επισήμανσης',
    clear: 'Καθαρισμός',
    link: 'Σύνδεσμος',
    attach: 'Επισυνάψτε αρχείο',
    tex: 'Εισαγωγή TeX',
    code: 'Κώδικας',
    image: 'Εισαγωγή εικόνας',
    insertHorizontalRule: 'Εισαγωγή οριζόντιας γραμμής',
    superscript: 'Εκθέτης',
    subscript: 'Δεικτής',
    insertTable: 'Εισαγωγή πίνακα',
    insertGroup: 'Εισαγωγή ομάδας',
    hiliteGroup: 'Ομάδα επισήμανσης',
    removeGroup: 'Αφαίρεση ομάδας',
    insertAnchor: 'Εισαγωγή άγκυρας',
    mergeCells: 'Συγχώνευση κελιών',
    splitCells: 'Διαχωρισμός κελιών',
    rowsColumnsManaging: 'Διαχείριση σειρών και στηλών',
    cellColor: 'Χρώμα κελιού',
    setDetails: 'Λεπτομέρειες',
    removeDetails: 'Αφαίρεση λεπτομερειών'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'άγκυρα'
  },
  editorTableCommands: [['Εισαγωγή στήλης πριν', 'Εισαγωγή στήλης μετά'], ['Εισαγωγή σειράς πριν', 'Εισαγωγή σειράς μετά'], ['Διαγραφή στήλης', 'Διαγραφή σειράς']],
  editorCodeOptions: ['Κώδικας στο κείμενο', 'Κώδικας σε μπλοκ'],
  editorFontOptions: {
    small: 'Μικρό',
    large: 'Μεγάλο',
    normal: 'Κανονικό',
    title: 'Τίτλος',
    subtitle: 'Υπότιτλος'
  }
};
const TUI_GREEK_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Εμφάνιση/Απόκρυψη',
  paginationTexts: {
    pages: 'Σελίδες',
    linesPerPage: 'Γραμμές ανά σελίδα',
    of: 'από'
  }
};
const TUI_GREEK_LANGUAGE_COUNTRIES = {
  AD: 'Ανδόρρα',
  AE: 'Ηνωμένα Αραβικά Εμιράτα',
  AF: 'Αφγανιστάν',
  AG: 'Αντίγκουα και Μπαρμπούδα',
  AI: 'Ανγκουίλα',
  AL: 'Αλβανία',
  AM: 'Αρμενία',
  AO: 'Ανγκόλα',
  AR: 'Αργεντινή',
  AT: 'Αυστρία',
  AU: 'Αυστραλία',
  AW: 'Αρούμπα',
  AZ: 'Αζερμπαϊτζάν',
  BA: 'Βοσνία και Ερζεγοβίνη',
  BB: 'Μπαρμπάντος',
  BD: 'Μπαγκλαντές',
  BE: 'Βέλγιο',
  BF: 'Μπουρκίνα Φάσο',
  BG: 'Βουλγαρία',
  BH: 'Μπαχρέιν',
  BI: 'Μπουρούντι',
  BJ: 'Μπενίν',
  BL: 'Αγία Βαρθολομαία',
  BM: 'Βερμούδες',
  BN: 'Μπρουνέι',
  BO: 'Βολιβία',
  BQ: 'Καραϊβική Ολλανδία',
  BR: 'Βραζιλία',
  BS: 'Μπαχάμες',
  BT: 'Μπουτάν',
  BW: 'Μποτσουάνα',
  BY: 'Λευκορωσία',
  BZ: 'Μπελίζ',
  CA: 'Καναδάς',
  CD: 'Κονγκό - Κινσάσα',
  CF: 'Κεντροαφρικανική Δημοκρατία',
  CG: 'Κονγκό - Μπραζαβίλ',
  CH: 'Ελβετία',
  CI: 'Ακτή Ελεφαντοστού',
  CL: 'Χιλή',
  CM: 'Καμερούν',
  CN: 'Κίνα',
  CO: 'Κολομβία',
  CR: 'Κόστα Ρίκα',
  CU: 'Κούβα',
  CV: 'Πράσινο Ακρωτήρι',
  CW: 'Κουρασάο',
  CY: 'Κύπρος',
  CZ: 'Τσεχία',
  DE: 'Γερμανία',
  DJ: 'Τζιμπουτί',
  DK: 'Δανία',
  DM: 'Δομίνικα',
  DO: 'Δομινικανή Δημοκρατία',
  DZ: 'Αλγερία',
  EC: 'Εκουαδόρ',
  EE: 'Εσθονία',
  EG: 'Αίγυπτος',
  ER: 'Ερυθραία',
  ES: 'Ισπανία',
  ET: 'Αιθιοπία',
  FI: 'Φινλανδία',
  FJ: 'Φίτζι',
  FK: 'Νήσοι Φώκλαντ',
  FM: 'Ομοσπονδιακά Κράτη Μικρονησίας',
  FR: 'Γαλλία',
  GA: 'Γκαμπόν',
  GB: 'Ηνωμένο Βασίλειο',
  GD: 'Γρενάδα',
  GE: 'Γεωργία',
  GF: 'Γαλλική Γουιάνα',
  GH: 'Γκάνα',
  GI: 'Γιβραλτάρ',
  GL: 'Γροιλανδία',
  GM: 'Γκάμπια',
  GN: 'Γουινέα',
  GP: 'Γουαδελόπης',
  GQ: 'Ισημερινή Γουινέα',
  GR: 'Ελλάδα',
  GT: 'Γουατεμάλα',
  GW: 'Γουινέα-Μπισσάου',
  GY: 'Γουιάνα',
  HK: 'Χονγκ Κονγκ',
  HN: 'Ονδούρα',
  HR: 'Κροατία',
  HT: 'Αϊτή',
  HU: 'Ουγγαρία',
  ID: 'Ινδονησία',
  IE: 'Ιρλανδία',
  IL: 'Ισραήλ',
  IN: 'Ινδία',
  IQ: 'Ιράκ',
  IR: 'Ιράν',
  IS: 'Ισλανδία',
  IT: 'Ιταλία',
  JM: 'Τζαμάικα',
  JO: 'Ιορδανία',
  JP: 'Ιαπωνία',
  KE: 'Κένυα',
  KG: 'Κιργιστάν',
  KH: 'Καμπότζη',
  KM: 'Κομόρες',
  KN: 'Άγιος Κίτος και Νέβις',
  KP: 'Βόρεια Κορέα',
  KR: 'Νότια Κορέα',
  KW: 'Κουβέιτ',
  KY: 'Νήσοι Καϊμάν',
  KZ: 'Καζακστάν',
  LA: 'Λάος',
  LB: 'Λίβανος',
  LC: 'Άγια Λουκία',
  LI: 'Λιχτενστάιν',
  LK: 'Σρι Λάνκα',
  LR: 'Λιβερία',
  LS: 'Λεσόθο',
  LT: 'Λιθουανία',
  LU: 'Λουξεμβούργο',
  LV: 'Λετονία',
  LY: 'Λιβύη',
  MA: 'Μαρόκο',
  MC: 'Μονακό',
  MD: 'Μολδαβία',
  ME: 'Μαυροβούνιο',
  MF: 'Άγιος Μαρτίνος',
  MG: 'Μαδαγασκάρη',
  MK: 'Βόρεια Μακεδονία',
  ML: 'Μάλι',
  MM: 'Μιανμάρ (Βρουμενία)',
  MN: 'Μογγολία',
  MO: 'Μακάο',
  MQ: 'Μαρτινίκα',
  MR: 'Μαυριτανία',
  MS: 'Μονσεράτ',
  MT: 'Μάλτα',
  MU: 'Μαυρίκιος',
  MV: 'Μαλδίβες',
  MW: 'Μαλάουι',
  MX: 'Μεξικό',
  MY: 'Μαλαισία',
  MZ: 'Μοζαμβίκη',
  NA: 'Ναμίμπια',
  NC: 'Νέα Καληδονία',
  NE: 'Νίγηρας',
  NG: 'Νιγηρία',
  NI: 'Νικαράγουα',
  NL: 'Ολλανδία',
  NO: 'Νορβηγία',
  NP: 'Νεπάλ',
  NZ: 'Νέα Ζηλανδία',
  OM: 'Ομάν',
  PA: 'Παναμάς',
  PE: 'Περού',
  PF: 'Γαλλική Πολυνησία',
  PG: 'Παπούα Νέα Γουινέα',
  PH: 'Φιλιππίνες',
  PK: 'Πακιστάν',
  PL: 'Πολωνία',
  PT: 'Πορτογαλία',
  PW: 'Παλάου',
  PY: 'Παραγουάη',
  QA: 'Κατάρ',
  RE: 'Ρεϊνιόν',
  RO: 'Ρουμανία',
  RS: 'Σερβία',
  RU: 'Ρωσία',
  RW: 'Ρουάντα',
  SA: 'Σαουδική Αραβία',
  SB: 'Νήσοι Σολομώντος',
  SC: 'Σεϋχέλλες',
  SD: 'Σουδάν',
  SE: 'Σουηδία',
  SG: 'Σιγκαπούρη',
  SH: 'Αγία Ελένη',
  SI: 'Σλοβενία',
  SK: 'Σλοβακία',
  SL: 'Σιέρα Λεόνε',
  SM: 'Σαν Μαρίνο',
  SN: 'Σενεγάλη',
  SO: 'Σομαλία',
  SR: 'Σουρινάμ',
  ST: 'Σάο Τομέ και Πρίνσιπε',
  SV: 'Ελ Σαλβαδόρ',
  SX: 'Άγιος Μαρτίνος',
  SY: 'Συρία',
  SZ: 'Εσουατίνι',
  TC: 'Νήσοι Τερκς και Κάικος',
  TD: 'Τσαντ',
  TG: 'Τόγκο',
  TH: 'Ταϊλάνδη',
  TJ: 'Τατζικιστάν',
  TL: 'Τιμόρ-Λέστε',
  TM: 'Τουρκμενιστάν',
  TN: 'Τυνησία',
  TO: 'Τόγκα',
  TR: 'Τουρκία',
  TT: 'Τρινιντάντ και Τομπάγκο',
  TW: 'Ταϊβάν',
  TZ: 'Τανζανία',
  UA: 'Ουκρανία',
  UG: 'Ουγκάντα',
  US: 'Ηνωμένες Πολιτείες',
  UY: 'Ουρουγουάη',
  UZ: 'Ουζμπεκιστάν',
  VC: 'Άγιος Βικέντιος και Γρεναδίνες',
  VE: 'Βενεζουέλα',
  VG: 'Βρετανικές Παρθένοι Νήσοι',
  VN: 'Βιετνάμ',
  VU: 'Βανουάτου',
  WS: 'Σαμόα',
  XK: 'Κοσσόβο',
  YE: 'Υεμένη',
  YT: 'Μαγιότ',
  ZA: 'Νότια Αφρική',
  ZM: 'Ζάμπια',
  ZW: 'Ζιμπάμπουε',
  AC: 'Νήσος Ασένσιον',
  AS: 'Αμερικανική Σαμόα',
  AX: 'Νήσοι Όλαντ',
  CC: 'Νήσοι Κόκος (Κίλινγκ)',
  CK: 'Νήσοι Κουκ',
  CX: 'Νήσος Χριστουγέννων',
  EH: 'Δυτική Σαχάρα',
  FO: 'Νήσοι Φερόες',
  GG: 'Γκέρνζι',
  GU: 'Γκουάμ',
  IM: 'Νήσος Μαν',
  JE: 'Τζέρσεϋ',
  IO: 'Βρετανική Έδαφος στον Ινδικό Ωκεανό',
  KI: 'Κιριμπάτι',
  MH: 'Νήσοι Μάρσαλ',
  MP: 'Βόρειες Μαριάνες',
  NF: 'Νήσος Νόρφολκ',
  NR: 'Ναούρου',
  NU: 'Νιούε',
  PM: 'Άγιος Πιερ και Μικελόν',
  PR: 'Πουέρτο Ρίκο',
  PS: 'Παλαιστίνη',
  SJ: 'Σβαλμπάρδα και Γιαν Μαγιέν',
  SS: 'Νότιο Σουδάν',
  TA: 'Τριστάν ντα Κούνχα',
  TK: 'Τόκελαου',
  TV: 'Τουβαλού',
  VA: 'Άγιος Έδελφος',
  VI: 'Νήσοι Βρετανικές Παρθένοι',
  WF: 'Ουάλις και Φουτούνα'
};
const TUI_GREEK_LANGUAGE_CORE = {
  months: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
  close: 'Κλείσιμο',
  clear: 'Εκκαθάρισή',
  nothingFoundMessage: 'Δεν βρέθηκε τίποτα',
  defaultErrorMessage: 'Η τιμή είναι άκυρη',
  spinTexts: ['Προηγούμενο', 'Επόμενο'],
  shortWeekDays: ['Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'],
  countries: TUI_GREEK_LANGUAGE_COUNTRIES
};
const TUI_GREEK_LANGUAGE_KIT = {
  cancel: 'Ακύρωση',
  done: 'Ολοκληρώθηκε',
  more: 'Περισσότερα',
  otherDate: 'Άλλη ημερομηνία...',
  showAll: 'Εμφάνιση όλων',
  hide: 'Απόκρυψη',
  mobileCalendarTexts: ['Επιλογή ημέρας', 'Επιλογή εύρους', 'Επιλογή ημερών'],
  range: ['από', 'έως'],
  countTexts: ['Πρόσθεσε', 'Μείωσε'],
  time: {
    'HH:MM': 'ΩΩ:ΛΛ',
    'HH:MM AA': 'ΩΩ:ΛΛ π.μ./μ.μ.',
    'HH:MM:SS': 'ΩΩ:ΛΛ:ΔΔ',
    'HH:MM:SS AA': 'ΩΩ:ΛΛ:ΔΔ π.μ./μ.μ.',
    'HH:MM:SS.MSS': 'ΩΩ:ΛΛ:ΔΔ.ΜΜΜ',
    'HH:MM:SS.MSS AA': 'ΩΩ:ΛΛ:ΔΔ.ΜΜΜ π.μ./μ.μ.'
  },
  dateTexts: {
    DMY: 'ηη.μμ.εεεε',
    MDY: 'μμ.ηη.εεεε',
    YMD: 'εεεε.μμ.ηη'
  },
  digitalInformationUnits: ['Β', 'ΚιΒ', 'ΜιΒ'],
  passwordTexts: ['Εμφάνιση κωδικού', 'Απόκρυψη κωδικού'],
  copyTexts: ['Αντιγραφή', 'Αντιγράφηκε'],
  shortCalendarMonths: ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μαι', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
  pagination: ['Προηγούμενη σελίδα', 'Επόμενη σελίδα'],
  fileTexts: {
    loadingError: 'Η μεταφόρτωση απέτυχε',
    preview: 'Προεπισκόπηση',
    remove: 'Αφαίρεση'
  },
  inputFileTexts: {
    defaultLabelSingle: 'ή αφήστε το εδώ',
    defaultLabelMultiple: 'ή αφήστε τα εδώ',
    defaultLinkSingle: 'Επιλέξτε ένα αρχείο',
    defaultLinkMultiple: 'Επιλέξτε αρχεία',
    maxSizeRejectionReason: 'Το αρχείο είναι μεγαλύτερο από',
    formatRejectionReason: 'Λανθασμένος τύπος αρχείου',
    drop: 'Αφήστε το αρχείο εδώ',
    dropMultiple: 'Αφήστε τα αρχεία εδώ'
  },
  multiSelectTexts: {
    all: 'Επιλογή όλων',
    none: 'Αποεπιλογή όλων'
  },
  confirm: {
    yes: 'Ναι',
    no: 'Όχι'
  },
  previewTexts: {
    rotate: 'Περιστροφή'
  },
  zoomTexts: {
    zoomOut: 'Μέγεθος μικρότερο',
    zoomIn: 'Μεγέθυνση',
    reset: 'Επαναφορά'
  },
  phoneSearch: 'Πληκτρολογήστε χώρα ή κωδικό'
};
const TUI_GREEK_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_GREEK_LANGUAGE = {
  name: 'greek',
  ...TUI_GREEK_LANGUAGE_CORE,
  ...TUI_GREEK_LANGUAGE_KIT,
  ...TUI_GREEK_LANGUAGE_ADDON_TABLE,
  ...TUI_GREEK_LANGUAGE_ADDON_COMMERCE,
  ...TUI_GREEK_LANGUAGE_ADDON_EDITOR,
  ...TUI_GREEK_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_GREEK_LANGUAGE, TUI_GREEK_LANGUAGE_ADDON_COMMERCE, TUI_GREEK_LANGUAGE_ADDON_EDITOR, TUI_GREEK_LANGUAGE_ADDON_TABLE, TUI_GREEK_LANGUAGE_CORE, TUI_GREEK_LANGUAGE_COUNTRIES, TUI_GREEK_LANGUAGE_KIT, TUI_GREEK_LANGUAGE_LAYOUT };
